import {outter_post} from 'common/js/axios-helper';
import {OrganNoteApi} from "./constant/UrlMapper";


const host = '8880';

const list = (data) => {
    return outter_post(OrganNoteApi.List, data, host);
};

const update = (data) => {
    return outter_post(OrganNoteApi.Update, data, host);
};

const add = (data) => {
    return outter_post(OrganNoteApi.Add, data, host);
};

const dpstatus = (data) => {
    return outter_post(OrganNoteApi.DpStatus, data, host);
};

const detail = (data) => {
    return outter_post(OrganNoteApi.Detail, data, host);
};

const isExist = (data) => {
    return outter_post(OrganNoteApi.IsExist, data, host);
};

const delInfo = (data) => {
    return outter_post(OrganNoteApi.Delete, data, host);
};


export default {list, update, add, dpstatus, detail, isExist, delInfo}



// WEBPACK FOOTER //
// ./src/service/OrganNoteService.js